import Reflux from "reflux";
import _ from "lodash";

/**
 * Holds the transformer's currently drawn tool per layout — the exact
 * `{ x, y, w, h, a, matrix }` (design px, canvas-offset) that Transformer
 * renders into its SVG `<g transform>`, plus the `pageOffsetX`/`yOffset`
 * it baked into that matrix — both captured from the same determineBounds
 * snapshot the matrix was computed from, so consumers can strip them
 * without relying on their own copies, which can lag a reflow or a
 * deferred redraw. Transformer publishes it
 * synchronously in its commit phase, so consumers (FloatingStageItem)
 * position against the same data that gets painted instead of parsing it
 * back out of the DOM. Null when no tool is drawn (nothing selected, or a
 * plugin such as the text editor replaces the tool).
 *
 * Keyed by layout because split view mounts a Transformer per stage and
 * both can draw the same selection. Kept separate from TransformerStore:
 * that store's trigger channel is consumed by listeners (SizeAndPosition
 * panel, renderer elements) that expect triggers only while element
 * positions are actually transforming.
 */
const DrawnToolStore = Reflux.createStore({
  storeName: "DrawnToolStore",

  init() {
    this.drawnTools = {};
  },

  /**
   * @param {string} layout
   * @param {?{x: number, y: number, w: number, h: number, a: number,
   *   matrix: number[], pageOffsetX: number, yOffset: number}} tool
   */
  setDrawnTool(layout, tool) {
    if (_.isEqual(tool, this.drawnTools[layout])) return;
    this.drawnTools[layout] = tool;
    this.trigger(layout);
  },

  /**
   * @param {string} layout
   * @returns {?{x: number, y: number, w: number, h: number, a: number,
   *   matrix: number[], pageOffsetX: number, yOffset: number}}
   */
  getDrawnTool(layout) {
    return this.drawnTools[layout] ?? null;
  },
});

export default DrawnToolStore;
